export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/Demo/AutoDashboard/theme/components/scorecard/ScorecardView/ScorecardExport.js